/**
 * FirstHostHint — owner complaint: "its hard to even know that you have to
 * click on settings in lobby to go to lobby settings." A first-time-host
 * gets ONE non-blocking, tappable pill pointing at the Table Rules button
 * (top-right), shown once ever per browser, mirroring the FirstVisitHints
 * one-shot pattern (see FirstVisitHints.tsx).
 */
import { useEffect, useState } from 'react';

const HOST_HINT_KEY = 'tt:hostHintV1';

export function FirstHostHint({ isHost, onOpenSettings }: { isHost: boolean; onOpenSettings: () => void }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isHost) return;
    let seen = false;
    try { seen = !!localStorage.getItem(HOST_HINT_KEY); } catch { /* */ }
    if (seen) return;
    setShow(true);
    const t = window.setTimeout(() => dismiss(), 7000);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHost]);

  function dismiss() {
    try { localStorage.setItem(HOST_HINT_KEY, '1'); } catch { /* */ }
    setShow(false);
  }

  if (!show) return null;
  return (
    <div className="hall-hint-layer host-hint-layer">
      <button
        type="button"
        className="hall-hint-pill host-hint-pill"
        onClick={() => { dismiss(); onOpenSettings(); }}
      >
        Set the table rules — Table Rules ↗
      </button>
    </div>
  );
}
